/* global google, gmapAcfFields, agFeatures_agGmap */
const initGmap = () => {
  console.log('initGmap');

  const isAgGmapFeaturesEnabled = agFeatures_agGmap || false;
  if(isAgGmapFeaturesEnabled == 'false'){
    return ;
  }

  console.log('gmap features enabled');

  const { marker, styles } = gmapAcfFields;
  /*
      *  new_map
      *
      *  This function will render a Google Map onto the selected jQuery element
      *
      *  @type	function
      *  @date	8/11/2013
      *  @since	4.3.0
      *
      *  @param	$el (jQuery element)
      *  @return	n/a
      */
  const newMap = $el => {
    // var
    const $markers = $el.find('.marker');

    // vars
    const args = {
      zoom: 12,
      center: new google.maps.LatLng(0, 0),
      scrollwheel: false,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      mapTypeControl: false,
      scaleControl: false,
    };

    // create map
    const map = new google.maps.Map($el[0], args);

    // add a markers reference
    map.markers = [];

    // add markers
    $markers.each(function () {
      addMarker($(this), map);
    });

    // center map
    centerMap(map);

    // return
    window.map = map;

    return map;
  };

  /*
  *  add_marker
  *
  *  This function will add a marker to the selected Google Map
  *
  *  @type	function
  *  @date	8/11/2013
  *  @since	4.3.0
  *
  *  @param	$marker (jQuery element)
  *  @param	map (Google Map object)
  *  @return	n/a
  */

  const addMarker = ($marker, map) => {
    // var
    const latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));

    // create marker
    const mapMarker = new google.maps.Marker({
      position: latlng,
      map,
      icon: marker.url,
    });
    // add to array
    map.markers.push(mapMarker);
    if(styles){
      map.setOptions({ styles: JSON.parse(styles) });
    }


    // if marker contains HTML, add it to an infoWindow
    if ($marker.html()) {
      // create info window
      const infowindow = new google.maps.InfoWindow({
        content: $marker.html(),
      });

      // show info window when marker is clicked
      google.maps.event.addListener(mapMarker, 'click', function () {
        infowindow.open(map, mapMarker);
      });
    }
  };

  /*
  *  center_map
  *
  *  This function will center the map, showing all markers attached to this map
  *
  *  @type	function
  *  @date	8/11/2013
  *  @since	4.3.0
  *
  *  @param	map (Google Map object)
  *  @return	n/a
  */

  const centerMap = map => {
    // vars
    const bounds = new google.maps.LatLngBounds();

    // loop through all markers and create bounds
    $.each(map.markers, function (i, marker) {
      const latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
      bounds.extend(latlng);
    });
    // only 1 marker?
    if (map.markers.length == 1) {
      // set center of map
      map.setCenter(bounds.getCenter());
      map.setZoom(15);
    } else {
      // fit to bounds
      map.fitBounds(bounds);
    }
  };

  /*
  *  document ready
  *
  *  This function will render each map when the document is ready (page has loaded)
  *
  *  @type	function
  *  @date	8/11/2013
  *  @since	5.0.0
  *
  *  @param	n/a
  *  @return	n/a
  */
  // global var

  const main = () => {
    $('.gmap').each(function () {
      // create map
      console.log('map found');
      $(this).removeClass('gmap');
      newMap($(this));
    });
  }


  $(document).ready(() => {
    if($('body').hasClass('wp-admin')){
      //delay main execution in wp-admin
      $('body').on('ag.gmap.ready', main);
    } else {
      // Execute directly in front
      main();
    }
  })





};

window.initMap = initGmap;

export default initGmap;



// WEBPACK FOOTER //
// ./scripts/util/gmap.js